module.exports = __webpack_public_path__ + "fonts/b8d64aca2eb3e07d9243ab16560a7706.txt";